import React from "react";
import { Route, Routes, HashRouter } from "react-router-dom";
import Home from "../pages/home/HomeComponent";
import Splash from "../pages/splash/Splash";
import Education from "../pages/education/EducationComponent";
import Experience from "../pages/experience/Experience";
import Contact from "../pages/contact/ContactComponent";
import Projects from "../pages/projects/Projects";
import { settings } from "../portfolio.js";

export default function Main(propss) {
  const renderRoute = (Component, path) => (
    <Route path={path} element={<Component theme={propss.theme} setTheme={propss.setTheme} />} />
  );
  return (
    <div>
      <HashRouter basename="/">
        <Routes>
          {settings.isSplash ? renderRoute(Splash, "/") : renderRoute(Home, "/")}
          {renderRoute(Home, "/home")}
          {/* {renderRoute(Experience, "/experience")} */}
          {renderRoute(Education, "/education")}
          {renderRoute(Contact, "/contact")}
          {settings.isSplash ? renderRoute(Splash, "/splash") : null}
          {renderRoute(Projects, "/projects")}
        </Routes>
      </HashRouter>
    </div>
  );
}
